/**
 * @generated SignedSource<<8b0d6e37ef4db6d19c5b0541fba773a4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightPriceChangeIcon_entry$data = {
  readonly priceChange: number;
  readonly " $fragmentType": "FlightPriceChangeIcon_entry";
};
export type FlightPriceChangeIcon_entry$key = {
  readonly " $data"?: FlightPriceChangeIcon_entry$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightPriceChangeIcon_entry">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightPriceChangeIcon_entry",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "priceChange",
      "storageKey": null
    }
  ],
  "type": "FlightPrice",
  "abstractKey": null
};

(node as any).hash = "2f7128be8a8237919a1627135a42fe26";

export default node;
